import moment from 'moment-timezone';

export const laZona = "America/Guayaquil";
export const dateNow = moment().tz(laZona).format().split('T')[0];